// Subir el ÍCONO del cliente desde el avatar de la ficha (D8 de la tanda iVirtual, 09/10; ronda 2, D11).
//
// El ícono lo ve sólo el equipo (Listado y ficha) y NO es la marca del portal: tiene su propio
// endpoint, `POST client/<id>/icon/`, que lo sube, lo persiste solo y devuelve la URL. Hasta la ronda 2
// el avatar subía por el del portal (`client/<id>/portal/logo/`), así que cambiar el ícono le cambiaba
// al cliente el logo de su portal. No exige el portal en el plan —sólo un usuario de agencia con acceso
// al cliente (activo)—, así que el gesto se ofrece siempre. Lo que el campo acepta sale de
// `PortalAppearanceZone`, que es donde se definió contra `branding_logo_storage` del backend (el mismo
// storage y los mismos `reason_code`): dos listas acá y allá terminarían discrepando.
import {API_URL} from '../../../settings/local_settings';
import {uploadWithProgress} from '../../../utils/multipart';
import {LOGO_ACCEPTED_TYPES, LOGO_MAX_BYTES} from '../PortalAppearanceZone';

export {LOGO_ACCEPTED_TYPES};

const GENERIC_ERROR_KEY = 'portal_tab.branding_logo_upload_error';

/**
 * La clave del rechazo LOCAL (tipo o tamaño), o `null` si el archivo puede viajar. Es conveniencia:
 * el control real son los magic bytes del backend. El `accept` del input sólo filtra el diálogo.
 */
export function logoRejectionKey(file) {
    if (!file) return null;
    if (!LOGO_ACCEPTED_TYPES.split(',').includes(file.type)) return 'portal_tab.branding_logo_error_UNSUPPORTED_TYPE';
    if (file.size > LOGO_MAX_BYTES) return 'portal_tab.branding_logo_error_TOO_LARGE';
    return null;
}

// El `reason_code` del rechazo. Viaja en dos lugares: arriba de todo cuando el 413 lo cortó el proxy
// (`normalizeMultipartResponse`), o adentro de `errors`, que `ErrorResponse` manda como JSON en texto.
function reasonCodeOf(response) {
    if (!response) return null;
    if (response.reason_code) return response.reason_code;
    const errors = response.errors;
    if (errors && typeof errors === 'object' && !Array.isArray(errors)) return errors.reason_code || null;
    if (typeof errors !== 'string') return null;
    try {
        return (JSON.parse(errors) || {}).reason_code || null;
    } catch (e) {
        return null;
    }
}

/**
 * El texto del error de una subida: por `reason_code`, con las claves de la marca del portal
 * (`portal_tab.branding_logo_error_<reason>`, el mismo mapeo de `ClientPortalTab`).
 *
 * Una diferencia a propósito: sin clave, allá cae al `error_message` del backend y acá al genérico
 * traducido. Los mensajes del backend están en español, y esta tanda nació de una agencia con la
 * interfaz en inglés.
 */
export function logoUploadErrorMessage(response, t) {
    const reason = reasonCodeOf(response);
    const translated = reason ? t(`portal_tab.branding_logo_error_${reason}`, {defaultValue: ''}) : '';
    return translated || t(GENERIC_ERROR_KEY);
}

/** Sube el ícono. Nunca rechaza (`uploadWithProgress`): resuelve la respuesta con su `status`. */
export function uploadClientIcon(clientId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return uploadWithProgress(`${API_URL}client/${clientId}/icon/`, formData);
}

/** La URL nueva si la subida salió bien; `null` si no. */
export function uploadedIconUrl(response) {
    if (!response || response.status !== 'OK') return null;
    return (response.data && response.data.icon_url) || null;
}
